import { useState } from "react";
import { motion } from "framer-motion";
import { Dumbbell, PlayCircle, Bell, Check, Sparkles, Home, Timer } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const POINTS = [
  [Home, "تمارين منزلية وفي النادي"],
  [PlayCircle, "فيديوهات واضحة خطوة بخطوة"],
  [Timer, "برامج مرتبة حسب مستواك"],
];

export const WorkoutsComingSoon = ({ waitlisted: initial }) => {
  const [waitlisted, setWaitlisted] = useState(initial);
  const join = async () => {
    try {
      await api.post("/workouts/waitlist");
      setWaitlisted(true);
      toast.success("تم! بنبلغك أول ما تنطلق الميزة");
    } catch { toast.error("حاول مرة ثانية"); }
  };
  return (
    <div className="px-5 pt-10 pb-32 max-w-md mx-auto" dir="rtl" data-testid="workouts-coming-soon">
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
        className="relative overflow-hidden rounded-[2rem] orange-gradient text-white p-6 shadow-floating">
        <div aria-hidden className="absolute -top-10 -left-10 w-40 h-40 rounded-full bg-white/10" />
        <div aria-hidden className="absolute -bottom-12 -right-8 w-44 h-44 rounded-full bg-white/10" />
        <span className="relative inline-flex items-center gap-1 bg-white/20 backdrop-blur text-[11px] font-black px-3 py-1 rounded-full">
          <Sparkles className="w-3 h-3" /> قريباً
        </span>
        <div className="relative mt-5 w-16 h-16 rounded-2xl bg-white/20 backdrop-blur flex items-center justify-center">
          <Dumbbell className="w-8 h-8" />
        </div>
        <h1 className="relative mt-4 text-2xl font-black leading-snug" data-testid="workouts-coming-soon-title">ترقبوا الميزة الجديدة:<br />مكتبة التمارين</h1>
        <p className="relative mt-2 text-sm text-white/90 leading-relaxed">نجهّز لكم مكتبة تمارين كاملة بفيديوهات احترافية تكمّل رحلتك مع كالوفاي.</p>
      </motion.div>

      <ul className="mt-6 space-y-2.5">
        {POINTS.map(([Icon, text], i) => (
          <motion.li key={text} initial={{ opacity: 0, x: 12 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.15 + i * 0.07 }}
            className="flex items-center gap-3 bg-white rounded-2xl border border-neutral-100 shadow-card px-4 py-3">
            <span className="w-9 h-9 rounded-xl bg-brand-50 text-brand-600 flex items-center justify-center"><Icon className="w-4 h-4" /></span>
            <span className="text-sm font-bold text-neutral-800">{text}</span>
          </motion.li>
        ))}
      </ul>

      <button type="button" onClick={join} disabled={waitlisted} data-testid="workouts-notify-btn"
        className={`mt-6 w-full py-4 rounded-full font-black flex items-center justify-center gap-2 active:scale-[0.98] transition-transform ${waitlisted ? "bg-emerald-50 text-emerald-700" : "orange-gradient text-white shadow-floating"}`}>
        {waitlisted ? <><Check className="w-5 h-5" /> بنبلغك عند الإطلاق</> : <><Bell className="w-5 h-5" /> نبّهني عند الإطلاق</>}
      </button>
    </div>
  );
};
